import { type MappingProps, toExtendedOption } from "@hightouch/formkit";
import { Mapping } from "src/formkit/components";
import type { SharedProps } from ".";

export const FKMapping = ({
  name,
  error,
  options,
  fromOptions,
  fromLabel,
  fromIcon,
  creatable,
  creatableTypes,
  advanced,
  templates,
  mappingTypes,
  isDisabled,
  isPrimaryIdentityMapping,
  query: toQuery,
  fromQuery,
}: MappingProps & { creatable: any } & SharedProps) => (
  <Mapping
    isDisabled={isDisabled}
    isPrimaryIdentityMapping={isPrimaryIdentityMapping}
    advanced={advanced}
    creatable={creatable}
    creatableTypes={creatableTypes}
    error={error}
    fromType={fromOptions ? "destinationOnlyMapping" : undefined}
    fromIcon={fromIcon?.toString()}
    fromLabel={fromLabel}
    fromLoadingOptions={fromQuery.enabled ? fromQuery.isFetching : undefined}
    fromOptions={toExtendedOption(
      fromQuery.enabled ? fromQuery.data : fromOptions,
    )}
    fromReloadOptions={fromQuery.refetch}
    loading={fromQuery.isFetching}
    mappingTypes={mappingTypes}
    name={name}
    options={toExtendedOption(toQuery.enabled ? toQuery.data : options)}
    reload={toQuery.refetch}
    templates={templates || []}
  />
);
